module.exports = __webpack_public_path__ + "media/images/icons/icon_more_white-7eb9bafb6fadedcc39e83b5a2ecf2363.svg";